import { RouteObject } from "react-router-dom";

import ProtectedRoute from "../Routes/ProtectedRoute";
import { PredefinedWord } from "../Routes/Predefined";
import { ROUTES } from "../Routes/routes";

import CentralHubLayout from "../layouts/CentralHubLayout";

import DashboardAdminCentralHub from "../components/CentralHub/Admin/pages/DashboardAdminCentralHub";
import CentralProfile from "../components/CentralHub/Admin/pages/CentralProfile";
import Approvals from "../components/CentralHub/Admin/pages/Approvals";
import DesignerDashboard from "../components/CentralHub/Admin/components/DesignerDashboard";

import ReportDelayPage from "../components/CentralHub/ReportDelayPage";
import FinishedOrdersPage from "../components/CentralHub/FinishedOrdersPage";
import OrderTagDetails from "../components/CentralHub/OrderTagDetails";

import AddRestoration from "../components/CentralHub/AddRestoration";
import AddMaterial from "../components/CentralHub/Admin/pages/AddMaterial";
import AddShade from "../components/CentralHub/Admin/pages/AddShade";
import AddRejectionReason from "../components/CentralHub/Admin/pages/AddRejectionReason";
import AddOrderType from "../components/CentralHub/Admin/pages/AddOrderType";
import GuaranteeCard from "../components/CentralHub/GuaranteeCard";

import AddUsers from "../components/CentralHub/Admin/pages/AddUsers";
import UserLoginHistory from "../components/CentralHub/Admin/pages/UserLoginHistory";
import NotificationDetail from "../components/CentralHub/NotificationDetail";
import CheckBoxMaster from "../components/CentralHub/Admin/pages/CheckBoxMaster";
import GenerateCoupon from "../components/CentralHub/Admin/pages/GenerateCoupon";
import AdminstlpreviewNew from "../components/CentralHub/Admin/pages/AdminstlpreviewNew";

import AddSLA from "../components/CentralHub/Admin/pages/AddSLA";
import AdminReport from "../components/CentralHub/Admin/pages/AdminReport";

import DentistMillinglist from "../components/CentralHub/Admin/pages/DentistMillinglist";
import CancelOrderAdmin from "../components/CentralHub/Admin/pages/CancelOrderAdmin";
import ScheduleMaster from "../components/CentralHub/Admin/pages/ScheduleMaster";
import AddDeliverypartner from "../components/CentralHub/Admin/pages/AddDeliverypartner";
import AdminDeliveryPartner from "../components/CentralHub/Admin/pages/AdminDeliveryPartner";
import CompleteOrder from "../components/CentralHub/Admin/pages/CompleteOrders";
import AdminFileManagement from "../components/CentralHub/Admin/pages/AdminFileManagement";


import DesignerPerformance from "../components/CentralHub/Admin/pages/DesignerPerformance";
import DesignerCards from "../components/CentralHub/Admin/components/DesignerCards";
import DesignerChart from "../components/CentralHub/Admin/components/DesignerChart";
import DesignerLeaderboard from "../components/CentralHub/Admin/components/DesignerLeaderboard";
import DesignerTable from "../components/CentralHub/Admin/components/DesignerTable";
import DesignerHeatmap from "../components/CentralHub/Admin/components/DesignerHeatmap";

import ChangePassword from "../layouts/ChangePassword";

import MillingPerformance from "../components/CentralHub/Admin/pages/MillingPerformance";
import MillingResourceOverview from "../components/CentralHub/Admin/pages/MillingResourceOverview";
import DispatchOverview from "../components/CentralHub/Admin/pages/DispatchOverview";
import AdminRejectedOrder from "../components/CentralHub/Admin/pages/AdminRejectedOreder";
import TicketType from "../components/CentralHub/Admin/pages/TicketType";
import Priority from "../components/CentralHub/Admin/pages/Priority";
import ReplyRaiseTicket from "../components/CentralHub/Admin/pages/ReplyRaiseTicket";
import WarrantyClaimResponse from "../components/CentralHub/Admin/pages/WarrantyClaimResponse";
import OrderSearchPage from "../components/CentralHub/Admin/pages/OrderSearchPage";
import SLABreachMonitor from "../components/CentralHub/Admin/pages/SLABreachMonitor";
import AdminContactSupport from "../components/CentralHub/Admin/pages/AdminContactSupport";
import AdminRealtimeOrderTracking from "../components/CentralHub/Admin/pages/AdminRealtimeOrderTracking";
import CancellationManagement from "../components/CentralHub/Admin/components/CancellationManagement";
import CancellationReason from "../components/CentralHub/Admin/pages/CancellationReason";
import ScheduleOrders from "../components/CentralHub/Admin/pages/ScheduleOrders";
import Phasewisededuction from "../components/CentralHub/Admin/pages/Phasewisededuction";
import RatingAnalytics from "../components/CentralHub/Admin/pages/RatingAnalytics";
import InternalPerformanceRating from "../components/CentralHub/Admin/pages/InternalPerformanceRating";
import Ratingadvanceinfo from "../components/CentralHub/Admin/pages/Ratingadvanceinfo";
import RatingAnalyticsTabs from "../components/CentralHub/Admin/pages/Ratinganalyticstabs";
import PaymentTracking from "../components/CentralHub/Admin/pages/PaymentTracking";
import PaymentInvoices from "../components/CentralHub/Admin/pages/PaymentInvoices";
import InvoicePrintout from "../components/CentralHub/Admin/pages/InvoicePrintout";




export const centralHubRoutes: RouteObject[] = [
  {
    element: (
      <ProtectedRoute allowedRoles={[PredefinedWord.Roles.CENTRAL_HUB]} />
    ),
    children: [
      {
        element: <CentralHubLayout />,
        children: [
          { path: ROUTES.CENTRAL.CENTRAL_HUB_DashboardAdminCentralHub, element: <DashboardAdminCentralHub /> },
          { path: ROUTES.CENTRAL.REPORT_DELAY, element: <ReportDelayPage /> },
          { path: ROUTES.CENTRAL.CENTRAL_PROFILE, element: <CentralProfile /> },
          { path: ROUTES.CENTRAL.CENTER_APPROVALS, element: <Approvals /> },

          { path: ROUTES.CENTRAL.FINISHED_ORDERS, element: <FinishedOrdersPage /> },
          { path: ROUTES.CENTRAL.CENTRAL_HUB_ORDERTAGDETAILS, element: <OrderTagDetails /> },

          { path: ROUTES.CENTRAL.ADD_RESTORATION, element: <AddRestoration /> },
          { path: ROUTES.CENTRAL.ADD_MATERIAL, element: <AddMaterial /> },
          { path: ROUTES.CENTRAL.ADD_SHADE, element: <AddShade /> },
          { path: ROUTES.CENTRAL.ADD_REJECTION_REASON, element: <AddRejectionReason /> },
           { path: ROUTES.CENTRAL.CANCELLATION_REASON, element: <CancellationReason /> },
          { path: ROUTES.CENTRAL.ADD_ORDER_TYPE, element: <AddOrderType /> },

          { path: ROUTES.CENTRAL.CENTRAL_HUB_GUARANTEECARD, element: <GuaranteeCard /> },
          // { path: ROUTES.CENTRAL.CENTRAL_HUB_GUARANTEECARD, element: <WarrantyCard /> },

          { path: ROUTES.CENTRAL.ADD_USERS, element: <AddUsers /> },
          { path: ROUTES.CENTRAL.USER_LOGIN_HISTORY, element: <UserLoginHistory /> },

          { path: ROUTES.CENTRAL.CENTRAL_NotificationDetail, element: <NotificationDetail /> },

          { path: ROUTES.CENTRAL.CENTRAL_HUB_CHECKBOXMASTER, element: <CheckBoxMaster /> },
          { path: ROUTES.CENTRAL.ADD_GENERATECOUPON, element: <GenerateCoupon /> },
          { path: ROUTES.CENTRAL.CENTRAL_AdminstlpreviewNew, element: <AdminstlpreviewNew /> },
         { path: ROUTES.CENTRAL.CENTRAL_HUB_ADDSLA, element: <AddSLA /> },
          { path: ROUTES.CENTRAL.CENTRAL_AdminReport, element: <AdminReport /> },
          { path: ROUTES.CENTRAL.CENTRAL_DentistMillinglist, element: <DentistMillinglist /> },
          { path: ROUTES.CENTRAL.CENTRAL_CancelOrder, element: <CancelOrderAdmin /> },
          { path: ROUTES.CENTRAL.CENTRAL_AddDeliverypartner, element: <AddDeliverypartner /> },
          { path: ROUTES.CENTRAL.CENTRAL_AdminDeliveryPartner, element: <AdminDeliveryPartner /> },
           { path: ROUTES.CENTRAL.ScheduleMaster, element: <ScheduleMaster /> },
          { path: ROUTES.CENTRAL.CENTRAL_FileManagement,element: <AdminFileManagement />,},
   
  

          { path: ROUTES.CENTRAL.CENTRAL_CompleteOrder, element: <CompleteOrder /> },
          { path: ROUTES.CENTRAL.ChangePassword, element: <ChangePassword /> },
          { path: ROUTES.CENTRAL.CENTRAL_DesignerPerformance, element: <DesignerPerformance /> },
          { path: ROUTES.CENTRAL.CENTRAL_DesignerDasboard, element: <DesignerDashboard /> },
          { path: ROUTES.CENTRAL.CENTRAL_DesignerCards, element: <DesignerCards /> },
          { path: ROUTES.CENTRAL.CENTRAL_DesignerChart, element: <DesignerChart /> },
          { path: ROUTES.CENTRAL.CENTRAL_DesignerLeaderboard, element: <DesignerLeaderboard /> },
          { path: ROUTES.CENTRAL.CENTRAL_DesignerTable, element: <DesignerTable /> },
          { path: ROUTES.CENTRAL.CENTRAL_DesignerHeatmap, element: <DesignerHeatmap /> },
          { path: ROUTES.CENTRAL.CENTRAL_MillingPerformance, element: <MillingPerformance /> },
          { path: ROUTES.CENTRAL.CENTRAL_MillingResourceOverview, element: <MillingResourceOverview /> },
          { path: ROUTES.CENTRAL.CENTRAL_DispatchOverview, element: <DispatchOverview /> },
          { path: ROUTES.CENTRAL.TicketType, element: <TicketType /> },
          { path: ROUTES.CENTRAL.AdminRejectedOrder, element: <AdminRejectedOrder /> },
          { path: ROUTES.CENTRAL.Priority, element: <Priority /> },
          { path: ROUTES.CENTRAL.ReplyRaiseTicket, element: <ReplyRaiseTicket /> },
          { path: ROUTES.CENTRAL.WarrantyClaimResponse, element: <WarrantyClaimResponse /> },
          { path: ROUTES.CENTRAL.OrderSerachPage, element: <OrderSearchPage /> },
          { path: ROUTES.CENTRAL.SLABreachMonitor, element: <SLABreachMonitor /> },
          { path: ROUTES.CENTRAL.AdminContactSupport, element: <AdminContactSupport /> },
          { path: ROUTES.CENTRAL.AdminRealtimeOrderTracking, element: <AdminRealtimeOrderTracking /> },
          { path: ROUTES.CENTRAL.CENTRAL_ApproveRejectCancelOrder, element: <CancellationManagement /> },
           { path: ROUTES.CENTRAL.CENTRAL_ScheduleOrders, element: <ScheduleOrders/> },
          { path: ROUTES.CENTRAL.CENTRAL_Phasewisededuction, element: <Phasewisededuction /> },
          { path: ROUTES.CENTRAL.RatingAnalytics, element: <RatingAnalytics /> },
          { path: ROUTES.CENTRAL.RatingAnalytics, element: <Ratingadvanceinfo /> },
          { path: ROUTES.CENTRAL.RatingAnalyticsTabs, element: <RatingAnalyticsTabs /> },
          { path: ROUTES.CENTRAL.CENTRAL_PaymentTracking, element: <PaymentTracking /> },
          { path: ROUTES.CENTRAL.CENTRAL_PaymentInvoices, element: <PaymentInvoices /> },
          { path: ROUTES.CENTRAL.InternalPerformanceRating, element: <InternalPerformanceRating /> },
         { path: ROUTES.CENTRAL.CENTRAL_InvoicePrintout, element: <InvoicePrintout /> },
        
          


        ],
      },
    ],
  },
];